import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import actions from './actions';
import { merge } from '../../../utils/state';

export const initialState = {
  profileKey: null,
  isAuthenticated: false,
  error: null,
  isLoading: null,
  isLoginLoader: false,
  isSignupLoader: false,
};

export default function reducer(state = initialState, action = {}) {
  const { payload, type } = action;

  switch (type) {
    case actions.TYPES.SET_ARRIVAL_INITIALIZED: {
      return merge(state, {
        arrivalInitialized: true,
      });
    }
    case actions.TYPES.SET_PROFILE_KEY:
      return merge(state, {
        profileKey: payload.profileKey,
      });
    case actions.TYPES.SET_CURRENT_PROFILE: {
      const myProfileKey = get(payload, 'profileKey');
      return merge(state, {
        profileKey: myProfileKey,
        isAuthenticated: !isEmpty(myProfileKey),
      });
    }
    case actions.TYPES.SET_IS_AUTHENTICATED: {
      const update = { isAuthenticated: payload };
      return merge(state, update);
    }
    case actions.TYPES.SET_PROFILE_STATUS:
      return merge(state, {
        profileStatus: payload,
      });
    case actions.TYPES.UPDATING_CURRENT_PROFILE:
      return merge(state, {
        error: null,
        isLoading: true,
      });
    case actions.TYPES.UPDATING_CURRENT_PROFILE_SUCCESS:
      return merge(state, {
        isLoading: false,
      });
    case actions.TYPES.UPDATING_CURRENT_PROFILE_ERROR:
      return merge(state, {
        error: payload,
        isLoading: false,
      });
    case actions.TYPES.SET_LOGIN_ERROR:
      return merge(state, {
        loginError: payload,
        isLoginLoader: false,
        isSignupLoader: false,
      });
    case actions.TYPES.LOGIN_REQUEST:
      return merge(state, {
        isLoginLoader: true,
      });
    case actions.TYPES.LOGIN_SUCCESS:
      return merge(state, {
        isLoginLoader: false,
      });
    case actions.TYPES.LOGIN_FAILURE:
      return merge(state, {
        isLoginLoader: false,
      });
    case actions.TYPES.SIGNUP_REQUEST:
      return merge(state, {
        isSignupLoader: true,
      });
    case actions.TYPES.SIGNUP_SUCCESS:
      return merge(state, {
        isSignupLoader: false,
      });
    case actions.TYPES.SIGNUP_FAILURE:
      return merge(state, {
        isSignupLoader: false,
      });
    default:
      return state;
  }
}
